import { Button } from "antd";
import { useNavigate } from "react-router";
import { useContext, useState } from "react";
import moment from "moment";

import FormsList from "./FormsList";
import SubscriptionModal from "./SubscriptionModal";
import add from "../../assets/images/webToLead/add.svg";
import { getSubscriptionUserInfo } from "../../utils/utils";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const Web2LeadContainer = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { isWebToLeadCreate } = useContext(AuthContext);
  const subscription = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(subscription?.validTo);
  const isExpired = validToDate.isBefore(currentDate);
  const dayDiff = currentDate.diff(validToDate, "days");

  const [isOpen, setIsOpen] = useState(false);

  const checkPermission = () => {
    if (!isWebToLeadCreate) {
      showAlert(
        "warning",
        "Permission Denied",
        "You do not have permission to access this resource"
      );
    } else {
      navigate("/settings/web-to-lead/create-form");
    }
  };

  const showModal = () => {
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div className="web-to-lead">
      <div className="d-flex justify-content-center font-roboto padd-90">
        <div className="settings-card" style={{ width: "100%" }}>
          <h1
            className="heading24px fw-bold"
            style={{
              paddingBottom: 5,
              borderBottom: "1px solid #ccc",
              width: "100%",
            }}
          >
            Web to Lead Setup
          </h1>
          <div className="d-flex justify-content-end align-items-center mt20">
            <Button
              type="primary"
              className="theme-btn"
              onClick={() => {
                if (!subscription?.id || (isExpired && dayDiff > 7)) {
                  showModal();
                } else {
                  checkPermission();
                }
              }}
            >
              <img src={add} width={12} height={12} alt="" /> New Form
            </Button>
          </div>
          <FormsList onSubscription={() => setIsOpen(true)} />
          <SubscriptionModal isOpen={isOpen} handleCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
};

export default Web2LeadContainer;
